import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkbox-reveal"
export default class extends Controller {
  static targets = ['checkbox', 'container']

  fadeIn() {
    let opacity = 0.1
    container.style.display = 'flex'
    const timer = setInterval(() => {
      if (opacity >= 1) {
        clearInterval(timer)
      }
      container.style.opacity = opacity
      container.style.filter = `alpha(opacity=${opacity * 100})`
      opacity += opacity * 0.1
    }, 10)
  }
  fadeOut() {
    let opacity = 1
    const timer = setInterval(() => {
      if (opacity <= 0.1) {
        clearInterval(timer)
        container.style.display = 'none'
      }
      container.style.opacity = opacity
      container.style.filter = `alpha(opacity=${opacity * 100})`
      opacity -= opacity * 0.1
    }, 30)
  }
  
  show(container) {
    container.classList.remove('hide')
    container.classList.add('show')
  }
  hide(container) {
    container.classList.remove('show')
    container.classList.add('hide')
  }
  
  toggle() {
    const checkbox  = this.checkboxTarget
    const container = this.containerTarget
    return (checkbox.checked) ? this.show(container) : this.hide(container)
  }
  connect() {
    this.toggle()
  }
  change() {
    console.log('clicked')
    this.toggle()
  }
}